module.exports = __webpack_public_path__ + "img/cx_icon_03.png";